import * as api from 'store/api'
import { UPDATE_CART_SUMMARY } from 'shared/constants'
import { errorMessage, successMessage } from 'lib/flash-message'
import { getCurrentUser } from 'shared/utils/getCurrentUser/getCurrentUser'

export const SET_REGISTRY_PRODUCT_IDS = 'SET_REGISTRY_PRODUCT_IDS'
export const setRegistryProductIds = (productIds) => {
  return {
    type: SET_REGISTRY_PRODUCT_IDS,
    productIds,
  }
}

/**
 * BL-6143 Borrowed from RegistryApp redux setup.
 */
export const SET_USER = 'SET_USER'
export const setUser = (user) => {
  return {
    type: SET_USER,
    user,
  }
}

/**
 * BL-6143 Borrowed from RegistryApp redux setup.
 */
export const SET_IS_MOBILE = 'SET_IS_MOBILE'
export const setIsMobile = (isMobile) => ({ type: SET_IS_MOBILE, isMobile })

export const ADD_REGISTRY_PRODUCT_ID = 'ADD_REGISTRY_PRODUCT_ID'
export const addRegistryProductId = (productId) => {
  return {
    type: ADD_REGISTRY_PRODUCT_ID,
    productId,
  }
}

/**
 * @typedef AddProductToRegistryOptions
 * @type {object}
 * @property {boolean} includeRecommendation – Includes Add Next Recommendation in response.
 *
 * @typedef RegItemFields
 * @type {object}
 * @property {string} title
 * @property {number} price
 * @property {number} quantity
 * @property {number} category_id
 */

/**
 * @param {number} productId
 * @param {RegItemFields} regItemFields
 * @param {AddProductToRegistryOptions} options
 *
 * @return {Promise<RegItemPostResponse>}
 */
export const addProductToRegistry = (productId, regItemFields, options) => {
  return (dispatch) => {
    const currentUser = getCurrentUser()

    if (currentUser && currentUser.registryId) {
      return api
        .addToBabylist(
          {
            ...regItemFields,
            product_id: productId,
            registryId: currentUser.registryId,
          },
          options
        )
        .then((resp) => {
          dispatch(addRegistryProductId(productId))
          return resp
        })
    }
    return Promise.reject()
  }
}

export const SET_CART_PRODUCT_IDS = 'SET_CART_PRODUCT_IDS'
export const setCartProductIds = (productIds) => {
  return {
    type: SET_CART_PRODUCT_IDS,
    productIds,
  }
}

export const ADD_CART_PRODUCT_ID = 'ADD_CART_PRODUCT_ID'
export const addCartProductId = (productId) => {
  return {
    type: ADD_CART_PRODUCT_ID,
    productId,
  }
}

export const addProductAvailabilitySubscription = (productId) => {
  return (dispatch) => {
    return api
      .addProductAvailabilitySubscription(productId)
      .then(() => {
        successMessage("We'll email you when this item is back in stock!")
      })
      .catch(() => {
        errorMessage()
      })
  }
}

export const addProductToCart = (productId, data) => {
  return (dispatch, getState) => {
    return api.addCartItem(data).then(() => {
      dispatch(addCartProductId(productId))
      PubSub.publish(UPDATE_CART_SUMMARY)
    })
  }
}

export const SET_ACTIVE_SORT_PARAMS = 'SET_ACTIVE_SORT_PARAMS'
export const setActiveSortParams = (activeSortParams) => {
  return {
    type: SET_ACTIVE_SORT_PARAMS,
    activeSortParams,
  }
}

export const SET_CATEGORIES = 'SET_CATEGORIES'
export const setCategories = (categories) => {
  return {
    type: SET_CATEGORIES,
    categories,
  }
}

export const SET_CATEGORY_TREE = 'SET_CATEGORY_TREE'
export const setCategoryTree = (categoryTree) => {
  return {
    type: SET_CATEGORY_TREE,
    categoryTree,
  }
}

export const maybeFetchChildCategoryProducts = (categorySlug) => {
  return (dispatch, getState) => {
    // Temporarily disable eager loading of child category products
    return Promise.resolve()
  }
}

export const SET_CASH_FUND_PREFERENCES = 'SET_CASH_FUND_PREFERENCES'
export const setCashFundPreferences = (preferences) => {
  return {
    type: SET_CASH_FUND_PREFERENCES,
    preferences,
  }
}

export const saveCashFundPreferences = (data) => {
  return (dispatch) => {
    return api
      .saveCashFundPreferences(data)
      .then((resp) => {
        dispatch(setCashFundPreferences(resp))
      })
      .catch((resp) => Promise.reject(parseErrors(resp)))
  }
}
